export default "__VITE_ASSET__U8GWWU$V__"